import {UrlManager} from './types';

export class WindowUrlManager implements UrlManager {
  getPath() {
    return window.location.pathname;
  }

  getQueryStringParam(paramName: string) {
    let paramVal = new URLSearchParams(window.location.search).get(paramName);
    if (paramVal === null) {
      paramVal = new URLSearchParams(window.location.hash).get(paramName); // wtf dashboards
    }
    return paramVal;
  }
}
